import { ViewProcessor } from "./index";
import { View } from "../index";

const triggerAttribute = 'data-flipcard-click-toggle';
const selector = `[${triggerAttribute}]`;

export default class FlipcardViewProcessor extends ViewProcessor
{
    public afterRender(view: View): PromiseLike<void>
    {
        let flipCards = view.querySelector(selector);

        for(let element of flipCards)
        {
            element.addEventListener('click', (e) => 
            {
                if (e.target && !(e.target as HTMLElement).hasAttribute('data-no-flipcard-toggle'))
                {
                    element.classList.toggle('toggled');
                }
            });
        }

        return super.afterRender(view);
    }
}